<ng-container *transloco="let t">
  <!-- Subscription Plans Modal -->
  @if (showPlansModal()) {
  <div class="fixed bg-black/70 inset-0 z-40 flex justify-center items-center backdrop-blur-sm">
    <div class="w-[80vw] shadow-[0px_8px_32px_rgba(0,0,0,0.15)]">
      <dss-libs-ui-base-modal (closed)="closePlansModal()">
        <div class="px-4 flex flex-col gap-6 overflow-auto max-h-[80vh]">
          <h2 class="text-navy font-semibold text-xl md:text-4xl text-center">
            {{ t('PAYMENT.SUBSCRIPTION_MODAL_TITLE') }}
          </h2>
          <p class="text-sm md:text-lg text-center text-ink-subtle">
            {{ t('PAYMENT.SUBSCRIPTION_MODAL_DESCRIPTION') }}
          </p>
          <ul class="toggle-buttons">
            <li
              [class]="selectedPlanBillingPeriod === BillingPeriod.Month ? 'text-white!' : ''"
              class="toggle-buttons__item"
            >
              <button (click)="selectPlanBillingPeriod(BillingPeriod.Month)" class="w-full h-full py-4">
                {{ t('PAYMENT.MONTHLY') }}
              </button>
            </li>
            <!-- //TODO : Enable yearly plans when available -->
            <li
              [class]="selectedPlanBillingPeriod === BillingPeriod.Month ? 'inset-s-0' : 'inset-s-28'"
              class="toggle-buttons__indicator"
            ></li>
          </ul>
          <div class="flex flex-wrap justify-center gap-8 pb-10">
            @for (plan of subscriptionPlans(); track plan.id) { @if (plan.period === selectedPlanBillingPeriod) {
            <div class="rounded-3xl bg-primary p-4 md:p-10 text-white w-80 flex flex-col gap-6">
              <p class="text-2xl md:text-4xl font-extrabold">
                {{ plan.price | translocoCurrency : 'narrowSymbol' : {} : plan.currency }}
                <span class="text-xs md:text-base font-medium"> / {{ t(plan.period.toUpperCase()) }} </span>
              </p>
              <p class="text-xl md:text-3xl font-extrabold">{{ plan.name }}</p>
              @if (plan.description) {
              <p class="text-xs md:text-base font-medium">
                {{ plan.description }}
              </p>
              } @if (plan.features.length) {
              <ul class="text-xs md:text-base">
                @for (feature of plan.features; track $index) {
                <li class="flex gap-3 mb-2">
                  <img height="21" src="/images/icons/check-circle.svg" width="20" alt="" />
                  <p class="font-medium">{{ feature }}</p>
                </li>
                }
              </ul>
              }
              <button
                (click)="selectPlan(plan.paymentBrokerPriceId)"
                class="w-full py-3 text-sm md:text-base font-extrabold bg-white text-primary rounded-3xl mt-auto"
              >
                {{ t('PAYMENT.CHOOSE_PLAN') }}
              </button>
            </div>
            } }
          </div>
        </div>
      </dss-libs-ui-base-modal>
    </div>
  </div>
  }
  <a
    [attr.data-cb-item-0]="dynamicPlanId"
    [attr.data-cb-type]="'checkout'"
    [id]="dynamicPlanId"
    class="hidden"
    href="javascript:void(0)"
  >
  </a>
</ng-container>
